
<template>

	<div :style="'position: relative;' + ( level > 0 ? 'padding-left: 5px; border-left: 5px solid ' + ( level > colors.length - 1 ? 'gray' : colors[level] ) : '' )">

		<v-context-menu ref="context_menu">

			<b-dropdown-item v-if="selected_index != null" v-on:click="() => delete_doing(selected_index)">Удалить</b-dropdown-item>

		</v-context-menu>

		<b-button v-if="need_delete_button" size="sm" variant="light" class="filter-button" v-on:click="() => $emit('delete')" ><b-icon-trash/></b-button>

		<b-row v-for="( d, ind ) in doings" :key="ind" align-v="center">

			<b-col cols="2" md="auto" :style="level ? '' : 'padding-right: 0px'">

				<b-dropdown v-if="ind > 0" variant="outline-primary" size="sm" no-caret :text="d.op" style="width: 31px">

					<b-dropdown-item v-for="( op, op_ind ) in ops" :key="op_ind" v-on:click="() => set_op(d, op)">{{ op }}</b-dropdown-item>

				</b-dropdown>

			</b-col>

			<b-col>

				<branch v-if="d.id && d.is_branch" :level="level + 1" :ref="'d_' + d.id" :attrs="attrs_base" :attr_type="attr_type" :attr_reference="attr_reference" in_doing v-on:need_check="() => $emit('need_check')" v-on:delete="() => delete_doing(ind)" need_delete_button :is_correction="is_correction" />
				<doing v-else-if="d.id" :level="level + 1" :ref="'d_' + d.id" :attrs_base="attrs_base" :attr_type="attr_type" :attr_reference="attr_reference" in_doing v-on:need_check="() => $emit('need_check')" v-on:delete="() => delete_doing(ind)" need_delete_button :is_correction="is_correction" />
				<div v-else v-on:contextmenu="ev => context_menu(ind, ev)">

					<b-row>

						<b-col cols="6">

							<span v-if="is_correction">Значение корректировки</span>
							<v-select v-else v-model="d.operand" :options="operands" v-on:input="operand => set_operand(d, operand)" :clearable="false" appendToBody/>

						</b-col>

						<b-col cols="6">

							<v-select v-if="d.operand == 'Атрибут'" v-model="d.attr_id" :options="attrs" :reduce="obj => obj.id" :state="d.attr_state" label="name" :clearable="false" v-on:input="id => select_attr(d, id)" appendToBody>

								<template #search="{ attributes, events }">

									<input class="vs__search" v-bind="attributes" v-on="events"/>
									<b-icon-exclamation-circle v-if="! d.attr_state" variant="danger" style="height: auto;"/> 

								</template>

							</v-select>

							<div v-else style="position: relative">

								<v-select v-if="attr_reference" :options="attr_reference_prepared" :reduce="obj => obj.value" :clearable="false" :state="d.value_state" v-model="d.value" v-on:input="value => set_value(d, value)" appendToBody>

									<template #search="{ attributes, events }">

										<input class="vs__search" v-bind="attributes" v-on="events"/>
										<b-icon-exclamation-circle v-if="! d.value_state" variant="danger" style="height: auto;"/> 

									</template>

								</v-select>

								<v-select v-else-if="attr_type == 'bool'" :options="bool_reference" :reduce="obj => obj.value" :clearable="false" :state="d.value_state" v-model="d.value" v-on:input="value => set_value(d, value)" appendToBody>

									<template #search="{ attributes, events }">

										<input class="vs__search" v-bind="attributes" v-on="events"/>
										<b-icon-exclamation-circle v-if="! d.value_state" variant="danger" style="height: auto;"/> 

									</template>

								</v-select>

								<b-form-input v-else-if="attr_type == 'str'" :state="d.value_state" v-model="d.value" v-on:input="value => set_value(d, value)"/>
								<b-form-input v-else-if="attr_type == 'number'" type="number" :gt="is_correction_mult ? 0 : undefined" :state="d.value_state" v-model="d.value" v-on:input="value => set_value(d, value)"/>
								<date_picker v-else-if="attr_type == 'date'" :state="d.value_state" v-model="d.value" v-on:input="value => set_value(d, value)"/>
								<b-form-timepicker v-else-if="attr_type == 'time'" :state="d.value_state" v-model="d.value" v-on:input="value => set_value(d, value)" label-no-time-selected="Значение не выбрано" label-close-button="Закрыть" label-hours="Часы" label-minutes="Минуты"/>
								<datetime_picker v-else-if="attr_type == 'datetime'" :ref="'d_datetime_' + d.id" :config="datetime_config" :state="d.value_state" :value="d.value" v-on:input="value => set_value(d, value)"/>

							</div>

						</b-col>

					</b-row>

				</div>

			</b-col>
			
		</b-row>

		<b-dropdown v-if="(doings.length == 0 || ops.length) && (doings.length < 1 || !is_correction)" variant="outline-primary" no-caret text="+ Добавить" size="sm" class="mt-2">

			<b-dropdown-item v-on:click="() => add_simple_doing()">Действие</b-dropdown-item>
			<b-dropdown-item v-if="ops.length && !is_correction" v-on:click="() => add_doing()">Группа действий</b-dropdown-item>
			<b-dropdown-item v-if="!is_correction" v-on:click="() => add_branch()">Группа условий</b-dropdown-item>

		</b-dropdown>

	</div>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../../api"
import branch from "./branch"
import date_picker from "../../widgets/date_picker"

export default
{
	name : "doing",

	props :
	{
		attrs_base : Array,
		attr_type : String,
		attr_reference : Object,
		level : { type : Number, default : () => 0 },
		in_doing : Boolean,
		need_delete_button : Boolean,
		is_correction : { type : Boolean, default : () => false },
		is_correction_mult : { type : Boolean, default : () => false },
	},

	components :
	{
		branch,
		date_picker,
	},

	data()
	{
		return {

			attrs : [],
			doings : [],
			ops : [],
			operands : [ "Атрибут", "Значение" ],
			bool_reference : [ { value : true, label : "Да" }, { value : false, label : "Нет" } ],
			colors : [ "red", "green", "blue", "yellow", "orange", "violet" ],
			selected_index : null,

			datetime_config :
			{
				locale : "ru",
				sideBySide : true,
				collapse : false,
				widgetPositioning : { vertical : "bottom", horizontal : "auto" },
				icons :
				{
					time : "far fa-clock",
					date : "far fa-calendar",
					up : "fas fa-arrow-up",
					down : "fas fa-arrow-down",
					previous : "fas fa-chevron-left",
					next : "fas fa-chevron-right",
					today : "fas fa-calendar-check",
					clear : "far fa-trash-alt",
					close : "far fa-times-circle"
				}
			},

		}
	},

	watch :
	{
		attrs_base :
		{
			immediate : true,

			handler(attrs_base)
			{
				if(attrs_base)
				{
					this.set_attrs_ops(attrs_base)
				}
			}
		},

		attr_type :
		{
			immediate : true,

			handler(attr_type)
			{
				this.set_attrs_ops(null, attr_type)
			},
		},

		attr_reference :
		{
			immediate : true,

			handler(attr_reference)
			{
				this.set_attrs_ops(null, null, attr_reference)
			},
		},
	},

	methods :
	{
		add_simple_doing()
		{
			this.doings.push({ attr_id : null, attr_stare : false, ops : [], op : this.ops.length ? this.ops[0] : null, is_branch : false,
				operand : this.is_correction ? this.operands[1] : this.operands[0],
				value : null, value_state : false, attr_state : false
			})

			this.$emit("need_check")
		},

		add_doing()
		{
			const id = uuid.v1().replaceAll("-", "_")

			this.doings.push({ id : id, ops : [], op : this.ops.length ? this.ops[0] : null, is_branch : false })
			this.$emit("need_check")
		},

		add_branch()
		{
			this.doings.push({ id : uuid.v1().replaceAll("-", "_"), ops : [], op : this.ops.length ? this.ops[0] : null, is_branch : true })

			this.$emit("need_check")
		},

		delete_doing(ind)
		{
			this.doings.splice(ind, 1)

			this.$emit("need_check")
		},

		set_attrs_ops(attrs_base, attr_type, attr_reference)
		{
			if(attrs_base == null)
				attrs_base = this.attrs_base

			if(attr_type == null)
				attr_type = this.attr_type

			if(attr_reference == null)
				attr_reference = this.attr_reference

			if(attr_type == "str" && attr_reference == null)
				this.ops = [ "+" ]
			else if(attr_type == "bool")
				this.ops = [ "+", "*" ]
			else if(attr_type == "number")
				this.ops = [ "+", "-", "/", "*" ]
			else
				this.ops = []

			this.attrs = this.attrs_base.filter(attr => attr.type == attr_type && ( ( attr.refererence == null && attr_reference == null ) || ( attr.reference != null && attr_reference != null && attr.reference.id == attr_reference.id) ) )

			if(attr_reference)
			{
				this.attr_reference_prepared = []

				attr_reference.values.forEach(value => this.attr_reference_prepared.push({ value : value, label : api.format_reference(attr_reference, value) }))
			}
			else
				this.attr_reference_prepared = null
		},

		set_op(d, op)
		{
			d.op = op

			this.$emit("need_check")
		},

		set_operand(d, operand)
		{
			d.operand = operand

			if(this.attr_type == "datetime" && operand == "Значение")
			{
				this.$nextTick(
					() =>
					{
						global.jQuery = require('jquery')
						var $ = global.jQuery
						this.$refs["d_datetime_" + d.id][0].dp.widgetParent($("#script_modal"))
					})
			}

			this.$emit("need_check")
		},

		select_attr(d, attr_id)
		{
			d.attr_id = attr_id
			d.attr_state = !! attr_id

			this.$emit("need_check")
		},

		set_value(d, value)
		{
			if(this.attr_type == "datetime")
				d.value = new Date(value)
			else
				d.value = value

			d.value_state = ( value != null && ( typeof value != "string" || value != "" ) )

			this.$emit("need_check")
		},

		get()
		{
			var desc = { doings : [] }

			if(this.doings.length == 0)
				throw "Пустое действие"

			this.doings.forEach(
				d =>
				{
					if(d.id)
					{
						const key = "d_" + d.id
						var save_d = this.$refs[key][0].get()

						save_d.ops = d.ops
						save_d.op = d.op
						save_d.is_branch = d.is_branch

						desc.doings.push(save_d)
					}
					else
					{
						if(( d.operand == "Значение" || d.attr_state ) && ( d.operand == "Атрибут" || d.value_state ))
						{
							var value = d.value

							if(this.attr_type == "number")
								value = Number(value)
							else if(this.attr_type == "datetime" || this.attr_type == "date")
								value = api.date_to_iso(value)

							desc.doings.push({ attr_id : d.attr_id, op : d.op, operand : d.operand, value : value, is_branch : false })
						}
						else
						{
							console.log("ERR", d)

							throw "Некорректное действие"
						}
					}
				})

			return desc
		},

		load(desc)
		{
			this.doings = []

			desc.doings.forEach(
				d =>
				{
					var new_d = { ops : [], op : this.ops.length ? this.ops[0] : null }

					if(d.doings || d.is_branch)
					{
						const id = uuid.v1().replaceAll("-", "_")

						new_d = { id : id, is_branch : d.is_branch }
						d.id = id

						this.set_op(new_d, d.op)

						this.doings.push(new_d)
					}
					else
					{
						new_d = { attr_id : null, attr_stare : false, is_branch : false, operand : this.operands[0], value : null, value_state : false, attr_state : false }

						this.set_op(new_d, d.op)
						this.set_operand(new_d, d.operand)
						this.select_attr(new_d, d.attr_id)
						this.set_value(new_d, d.value)

						this.doings.push(new_d)
					}
				})

			this.$nextTick(
				() =>
				{
					desc.doings.forEach(
						d =>
						{
							if(d.id)
							{
								const key = "d_" + d.id

								this.$refs[key][0].load(d)
							}
						})
				})
		},

		context_menu(index, event)
		{
			event.preventDefault()

			this.selected_index = index
			this.$refs.context_menu.open(event)
		},
	}
}

</script>

